import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '../ui/Button';

const periodLabels: Record<string, string> = {
  mensal: 'Mensal',
  trimestral: 'Trimestral',
  semestral: 'Semestral',
  anual: 'Anual',
};

const planLabels: Record<string, string> = {
  v1: 'V1',
  v2: 'V2',
  v3: 'V3',
  v4: 'V4',
  v5: 'V5',
  v6: 'V6',
  v7: 'V7',
};

type Props = {
  open: boolean;
  loading?: boolean;
  fromPlanId: string;
  fromPeriod: string;
  toPlanId: string;
  toPeriod: string;
  paymentLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export function PlanChangeConfirmDialog({
  open,
  loading,
  fromPlanId,
  fromPeriod,
  toPlanId,
  toPeriod,
  paymentLabel,
  onCancel,
  onConfirm,
}: Props) {
  if (!open) return null;

  const fromLabel = `${planLabels[fromPlanId] || fromPlanId.toUpperCase()} · ${periodLabels[fromPeriod] || fromPeriod}`;
  const toLabel = `${planLabels[toPlanId] || toPlanId.toUpperCase()} · ${periodLabels[toPeriod] || toPeriod}`;

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-slate-950/60 px-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="plan-change-title"
    >
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl border border-slate-100">
        <div className="flex items-start gap-3 mb-4">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700">
            <AlertTriangle className="h-6 w-6" />
          </div>
          <div>
            <h3 id="plan-change-title" className="text-lg font-bold text-slate-900">
              Trocar plano ou ciclo?
            </h3>
            <p className="mt-1 text-sm text-slate-600">
              Você já gerou um <strong>{paymentLabel}</strong> para{' '}
              <strong className="text-slate-800">{fromLabel}</strong>.
            </p>
          </div>
        </div>
        <p className="text-sm text-slate-700 mb-5 leading-relaxed">
          Ao confirmar, será gerado um novo <strong>{paymentLabel}</strong> para{' '}
          <strong className="text-slate-900">{toLabel}</strong>. O pagamento anterior deixa de ser o
          indicado neste checkout (não pague o QR/código antigo).
        </p>
        <div className="flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
          <Button type="button" variant="outline" className="w-full sm:w-auto" disabled={loading} onClick={onCancel}>
            Manter {fromLabel}
          </Button>
          <Button type="button" className="w-full sm:w-auto" disabled={loading} onClick={onConfirm}>
            {loading ? 'Gerando…' : 'Sim, gerar novo pagamento'}
          </Button>
        </div>
      </div>
    </div>
  );
}
